import { Tweener } from "./Tweener";
import { Pool } from "../utils/Pool";
import { Ease } from "./Ease";
export class Tween {
    static create(target, lifecycleOwner) {
        let tween = Tween._pool.take();
        tween._target = target;
        tween._lo = lifecycleOwner;
        return tween;
    }
    static isTweening(target) {
        return Tweener.isTweening(target);
    }
    static getTween(target) {
        tmpArray.length = 0;
        this.getTweens(target, tmpArray);
        return tmpArray.length > 0 ? tmpArray[0] : null;
    }
    static getTweens(target, out) {
        return Tweener.getTweens(target, out);
    }
    static kill(tween) {
        if (tween)
            tween.kill();
    }
    static clear(tween) {
        if (tween)
            tween.kill();
    }
    static killAll(target, completed) {
        return Tweener.killAll(target, completed);
    }
    static clearAll(target) {
        Tween.killAll(target);
    }
    static to(target, props, duration, ease, complete, delay, coverBefore) {
        if (coverBefore)
            Tween.killAll(target);
        let tween = Tween.create(target);
        Tween.tweenLegacy(tween.cur(true), props, duration, ease, complete, delay, true);
        return tween;
    }
    static from(target, props, duration, ease, complete, delay, coverBefore) {
        if (coverBefore)
            Tween.killAll(target);
        let tween = Tween.create(target);
        Tween.tweenLegacy(tween.cur(true), props, duration, ease, complete, delay, false);
        return tween;
    }
    static tweenLegacy(tweener, props, duration, ease, complete, delay, isTo) {
        tweener.duration = duration;
        for (let p in props) {
            let value = props[p];
            if (p in tweener.target) {
                isTo ? tweener.go(p, tweener.target[p], value) : tweener.go(p, value, tweener.target[p]);
            }
        }
        if (props.ease) {
            tweener.ease = props.ease;
            if (props.easeArgs)
                tweener.easeArgs.push(...props.easeArgs);
        }
        if (props.update) {
            tweener.onUpdate = props.update.runWith;
            tweener.onUpdateCaller = props.update;
        }
        if (props.complete) {
            tweener.onComplete = props.complete.runWith;
            tweener.onCompleteCaller = props.complete;
        }
        if (ease != null)
            tweener.ease = ease;
        if (delay != null)
            tweener.delay = delay;
        if (complete) {
            tweener.onComplete = complete.runWith;
            tweener.onCompleteCaller = complete;
        }
    }
    to(propName, value) {
        this.cur(true).go(propName, undefined, value);
        return this;
    }
    from(propName, value) {
        this.cur(true).go(propName, value, undefined);
        return this;
    }
    go(propName, startValue, endValue) {
        this.cur(true).go(propName, startValue, endValue);
        return this;
    }
    chain(target, lifecycleOwner) {
        if (target !== undefined) {
            this._target = target;
            this._lo = lifecycleOwner;
        }
        if (this._queue.length == 0)
            return this;
        if (this._par != null) {
            this._queue.push(-2);
            this._par = null;
        }
        this._cur = Tweener.create(this);
        this._cur.target = this._target;
        this._cur.lifecycleOwner = this._lo;
        this._queue.push(this._cur.id);
        return this;
    }
    parallel(target, lifecycleOwner) {
        if (this._queue.length == 0) {
            if (target !== undefined) {
                this._target = target;
                this._lo = lifecycleOwner;
            }
            return this;
        }
        if (this._par == null) {
            this._queue.push(-1);
            this._par = this._cur;
        }
        this._cur = Tweener.create(this);
        if (target !== undefined) {
            this._cur.target = target;
            this._cur.lifecycleOwner = lifecycleOwner;
        }
        else {
            this._cur.target = this._par.target;
            this._cur.lifecycleOwner = this._par.lifecycleOwner;
        }
        this._cur.duration = this._par.duration;
        if (this._par._active)
            this._cur.activate();
        this._queue.push(this._cur.id);
        return this;
    }
    delay(value) {
        this.cur(false).delay = value;
        return this;
    }
    duration(value) {
        this.cur(false).duration = value;
        return this;
    }
    breakpoint(value) {
        this.cur(false).breakpoint = value;
        return this;
    }
    ease(value, ...args) {
        let cur = this.cur(false);
        if (typeof (value) === "string")
            cur.ease = Ease[value];
        else
            cur.ease = value;
        cur.easeArgs.length = 0;
        if (args)
            cur.easeArgs.push(...args);
        return this;
    }
    interp(value, ...args) {
        let cur = this.cur(false);
        cur.interp = value;
        cur.interpArgs.length = 0;
        if (args)
            cur.interpArgs.push(...args);
        return this;
    }
    repeat(repeat, yoyo) {
        let cur = this.cur(false);
        cur.repeat = repeat;
        cur.yoyo = yoyo;
        return this;
    }
    timeScale(value) {
        this.cur(false).timeScale = value;
        return this;
    }
    ignoreEngineTimeScale(value) {
        this.cur(false).ignoreEngineTimeScale = value;
        return this;
    }
    snapping(value) {
        this.cur(false).snapping = value;
        return this;
    }
    userData(value) {
        this.cur(false).userData = value;
        return this;
    }
    name(value) {
        this.cur(false).name = value;
        return this;
    }
    onUpdate(callback, callbackThis) {
        let cur = this.cur(false);
        cur.onUpdate = callback;
        cur.onUpdateCaller = callbackThis;
        return this;
    }
    onStart(callback, callbackThis) {
        let cur = this.cur(false);
        cur.onStart = callback;
        cur.onStartCaller = callbackThis;
        return this;
    }
    then(callback, callbackThis) {
        let cur = this.cur(false);
        cur.onComplete = callback;
        cur.onCompleteCaller = callbackThis;
        return this;
    }
    waitForCompletion() {
        return new Promise((resolve) => {
            let cur = this.cur(false);
            if (!cur.onCompleteResolvers)
                cur.onCompleteResolvers = [];
            cur.onCompleteResolvers.push(resolve);
        });
    }
    seek(time) {
        this.cur(false).seek(time);
        return this;
    }
    pause() {
        forEach(this._queue, tween => tween.paused = true);
        return this;
    }
    resume() {
        forEach(this._queue, tween => tween.paused = false);
        return this;
    }
    findTweener(name) {
        for (let i = 0, n = this._queue.length; i < n; i++) {
            if (i < 0)
                continue;
            let tween = Tweener.getTween(this._queue[i]);
            if (tween && tween.name == name)
                return tween;
        }
        return null;
    }
    kill(complete) {
        if (this._queue.length == 0)
            return;
        let arr;
        for (let e of this._queue) {
            if (e > 0) {
                let tweener = Tweener.getTween(e);
                if (tweener) {
                    if (!tweener._killed) {
                        if (!arr)
                            arr = [];
                        arr.push(tweener);
                    }
                    tweener.owner = null;
                }
            }
        }
        this._head = -1;
        this._cur = null;
        this._queue.length = 0;
        if (arr != null)
            arr.forEach(t => t.kill(complete));
    }
    get completed() {
        return this._head >= 0 && this._queue.length === 0;
    }
    complete() {
        this.kill(true);
    }
    clear() {
        this.kill(false);
    }
    recover() {
        this.kill(false);
        Tween._pool.recover(this);
    }
    constructor() {
        this._queue = [];
        this._head = -1;
    }
    cur(call) {
        if (!this._cur) {
            if (this._head != -1) {
                if (call)
                    this.kill(false);
                else
                    throw new Error("Tween has been started. clear first!");
            }
            this._cur = Tweener.create(this);
            this._cur.target = this._target;
            this._cur.lifecycleOwner = this._lo;
            this._cur.activate();
            this._queue.push(this._cur.id);
        }
        return this._cur;
    }
    _check() {
        if (this._cur) {
            this._head = 0;
            this._cur = null;
        }
        let i = this._head, cnt = this._queue.length;
        for (; i < cnt; i++) {
            let id = this._queue[i];
            if (id < 0)
                continue;
            let tween = Tweener.getTween(id);
            if (tween && !tween._killed) {
                if (tween._active)
                    break;
                tween.activate();
                if (this._queue[i + 1] == -1) {
                    for (let j = i + 2; j < cnt; j++) {
                        let id = this._queue[j];
                        if (id < 0)
                            break;
                        let tween = Tweener.getTween(id);
                        if (tween && !tween._killed)
                            tween.activate();
                        else
                            this._queue[i] = -3;
                    }
                }
                break;
            }
            else
                this._queue[i] = -3;
        }
        this._head = i;
        if (i >= cnt)
            this._queue.length = 0;
    }
    static shake(time, start, end, result, amplitude) {
        if (time == 1) {
            result.length = 0;
            result.push(...start);
        }
        else {
            let am = amplitude * (1 - time);
            let am2 = am * (Math.random() > 0.5 ? 1 : -1);
            for (let i = 0; i < start.length; i++)
                result[i] = start[i] + am2;
        }
    }
    static seperateChannel(time, start, end, result, channels) {
        channels = channels || 3;
        for (let i = 0; i < start.length; i++)
            result[i] = interpByChannel(time, start[i], end[i], channels);
    }
    static useCurvePath(time, start, end, result, path) {
        let pt = path.getPointAt(time);
        result[0] = pt.x;
        if (result.length > 1)
            result[1] = pt.y;
        if (result.length > 2)
            result[2] = pt.z;
    }
}
Tween._pool = Pool.createPool(Tween);
const tmpArray = [];
function forEach(all, callback) {
    for (let e of all) {
        if (e > 0) {
            let tween = Tweener.getTween(e);
            if (tween && !tween._killed)
                callback(tween);
        }
    }
}
function interpByChannel(time, start, end, channels) {
    let v = 0;
    for (let i = 0; i < channels; i++) {
        let j = i * 8;
        let n0 = (start >> j) & 0xFF;
        let n1 = (end >> j) & 0xFF;
        v += (n0 + (n1 - n0) * time) << j;
    }
    return v;
}
